// ========= Copyright 2026 @ Strukto.AI All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2026 @ Strukto.AI All Rights Reserved. =========

import type { Workspace } from '@struktoai/mirage-core/workspace/workspace/workspace'
import type { Shell, ShellAction, ShellResult, ShellOutputResult } from '@openai/agents'
import { withRefusal } from '../io-text.ts'

export class MirageShell implements Shell {
  constructor(private readonly ws: Workspace) {}

  async run(action: ShellAction): Promise<ShellResult> {
    const output: ShellOutputResult[] = []
    for (const cmd of action.commands) {
      const io = await this.ws.execute(cmd)
      output.push({
        stdout: io.stdoutText,
        stderr: withRefusal(io.stderrText, io.refusal),
        outcome: { type: 'exit', exitCode: io.exitCode },
      })
    }
    return { output }
  }
}
